import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { ErrorUnexpected, OperationSuccessfully } from "../../../../../const/Messages";
import * as HubService from "../../../../../service/HubService";
import Loading from "../../../../Common/Loading/Loading";

const initialValues = {
  name: "",
};

/**
 * @author Thiago Guimarães
 * @date 06/04/2021
 */
function HubRegister() {
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location && location.state && location.state.id) {
      HubService.getById(location.state.id)
        .then((hub) => setValues(hub))
        .catch((error) => {
          history.push("/settings/partners/hub", {
            message: ErrorUnexpected,
            messageType: "error",
          });
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({
    name: Yup.string().required("Hub name is a required field"),
  });

  function handleSave(values, actions) {
    let id = null;

    if (location && location.state && location.state.id) {
      id = location.state.id;
    }

    HubService.merge(id, values)
      .then((response) => {
        history.push("/settings/partners/hub", {
          message: OperationSuccessfully,
          messageType: "success",
        });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          toast.error(ErrorUnexpected);
        } else if (error.response.data.fields) {
          error.response.data.fields.forEach((field) => {
            actions.setFieldError(field.name, field.message);
          });
        } else if (error.response.data.title) {
          actions.setFieldError("name", error.response.data.title);
        } else {
          toast.error(ErrorUnexpected);
        }
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  }

  function handleDelete(hub) {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        HubService.deleteById(hub.id).then(() => {
          history.push("/settings/partners/hub", {
            message: OperationSuccessfully,
            messageType: "success",
          });
        });
      }
    });
  }

  if (loading) {
    return <Loading />;
  }
  
  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>Hub - Register</h5>
          </div>
          <div className="ibox-content">
            <Formik initialValues={values} validationSchema={schema} onSubmit={handleSave}>
              {({ values, isSubmitting }) => (
                <Form>
                  <div className="form-group row">
                    <label htmlFor="name" className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1">
                      Name:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field name="name" className="form-control"></Field>
                      <span className="text-danger">
                        <ErrorMessage name="name" />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link className="mr-1 btn btn-primary" to="/settings/partners/hub">
                      Cancel
                    </Link>
                    {location && location.state && location.state.id && (
                      <Button className="mr-1" onClick={() => handleDelete(values)} variant="primary" type="button">
                        Delete
                      </Button>
                    )}
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                      {location && location.state && location.state.id ? "Update" : "Save"}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default HubRegister;
